import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';

export interface AdTypeObject {
  id: number;
  titleEn: string;
  titleAr: string;
  blug: string;
  is_active: boolean;
  icon: string;
  titleIcon: string;
  webIcon: string;
  titleWebIcon: string;
}
export interface AdTypesListInfo {
  totalItems: number;
  currentPage: number;
  pageSize: number;
  isNext: boolean;
  previous: number;
  adTypes: Array<AdTypeObject>;
  errors: unknown;
}
@Module
export default class AdTypesModule
  extends VuexModule
  implements AdTypesListInfo
{
  adTypes = [] as Array<AdTypeObject>;
  adAllTypes = [] as Array<AdTypeObject>;
  totalItems = 0;
  currentPage = 1;
  pageSize = 10;
  previous = 0;
  isNext = true;
  errors = {};

  /**
   * Get types list
   * @returns Array<AdTypeObject>
   */
  get adTypesList(): Array<AdTypeObject> {
    return this.adTypes;
  }

  /**
   * Get types list
   * @returns Array<AdTypeObject>
   */
  get adTypesAllList(): Array<AdTypeObject> {
    return this.adAllTypes;
  }

  /**
   * Get total items
   * @returns number
   */
  get adTypesListCount(): number {
    return this.totalItems;
  }

  @Mutation
  [Mutations.SET_AD_TYPES](data) {
    this.adTypes = data.data;
    this.totalItems = data.totalItems;
    this.currentPage = data.currentPage;
    this.pageSize = data.pageSize;
    this.isNext = data.isNext;
    this.previous = data.previous;
    this.errors = {};
  }

  @Mutation
  [Mutations.SET_AD_TYPE_CURRENT_PAGE](page) {
    this.currentPage = page;
  }

  @Mutation
  [Mutations.RESET_AD_TYPES_LIST]() {
    this.adTypes = [] as Array<AdTypeObject>;
    this.adAllTypes = [] as Array<AdTypeObject>;
    this.totalItems = 0;
    this.currentPage = 1;
    this.pageSize = 10;
    this.previous = 0;
    this.isNext = true;
    this.errors = {};
  }
  @Mutation
  [Mutations.SET_ALL_AD_TYPES](data) {
    this.adAllTypes = data.data;
  }

  @Action
  [Actions.RESET_AD_TYPES_STORE]() {
    this.context.commit(Mutations.RESET_AD_TYPES_LIST);
  }

  @Action
  [Actions.CREATE_AD_TYPE](data) {
    ApiService.setAuthorizationHeader();
    return ApiService.post('/ads-types', data)
      .then(() => {
        this.context.commit(Mutations.RESET_AD_TYPES_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.DELETE_AD_TYPE](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.delete('/ads-types', id)
      .then(() => {
        this.context.commit(Mutations.RESET_AD_TYPES_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_AD_TYPE]({ id, data }) {
    ApiService.setAuthorizationHeader();
    return ApiService.update('/ads-types', id, data)
      .then(() => {
        this.context.commit(Mutations.RESET_AD_TYPES_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_AD_TYPE_CURRENT_PAGE](val) {
    this.context.commit(Mutations.SET_AD_TYPE_CURRENT_PAGE, val);
  }

  @Action
  [Actions.GET_AD_TYPE](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/ads-types', id);
  }

  @Action
  [Actions.GET_AD_TYPES]() {
    ApiService.setAuthorizationHeader();
    return ApiService.query('/ads-types', {
      params: { page: this.currentPage },
    })
      .then(({ data }) => {
        this.context.commit(Mutations.SET_AD_TYPES, data);
      })
      .catch(({ response }) => {
        console.error(response);
        // this.context.commit(Mutations.SET_ERROR, {
        //   [response.statusText]: [response.data.message],
        // });
      });
  }
  @Action
  [Actions.GET_ALL_AD_TYPES]() {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/ads-types/all')
      .then(({ data }) => {
        this.context.commit(Mutations.SET_ALL_AD_TYPES, data);
      })
      .catch(({ response }) => {
        console.error(response);
      });
  }

  @Action
  [Actions.UPLOAD_ADS_TYPE_IMAGE]({ data, id }) {
    ApiService.setAuthorizationHeader();
    ApiService.setMultipartHeader();
    return ApiService.post(`/ads-types/uploadThumbnail/${id}`, data)
      .then(({ data }) => {
        return data.data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPLOAD_ADS_TYPE_WEB_IMAGE]({ data, id }) {
    ApiService.setAuthorizationHeader();
    ApiService.setMultipartHeader();
    return ApiService.post(`/ads-types/uploadThumbnailWeb/${id}`, data)
      .then(({ data }) => {
        return data.data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }
}
